export enum PaymentStatus {
  PENDING = 'pending',
  PAID = 'paid'
}

export interface ITicketAttributes {
  eventName: string
  payment_status: PaymentStatus
  email: string
  emmiter_note: string
  recipient_note: string
  price: number
  file?: string
}

export interface ITicket extends ITicketAttributes {
  uuid: string
  user: {
    id: number
    username: string
  }
  createdAt: string
  updatedAt: string
  deletedAt: string | null
}

export interface ITicketFormData {
  file: FileList
  eventName: string
  payment_status: PaymentStatus
  email: string
  emmiter_note: string
  recipient_note: string
  price: number
}

export interface ITicketUpdateFormData {
  file?: FileList
  eventName?: string
  payment_status?: PaymentStatus
  email?: string
  emmiter_note?: string
  recipient_note?: string
  price?: number
}